/* Public recording share page — parents watch the class recording in the
 * browser, no login. Link: /rec/:token (issued by the teacher's Share button). */
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Video, CalendarDays } from "lucide-react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export default function RecordingShare() {
  const { token } = useParams();
  const [rec, setRec] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    axios.get(`${BACKEND}/api/public/rec/${token}`)
      .then(({ data }) => setRec(data.recording))
      .catch((e) => setErr(e.response?.data?.detail || "This recording link is invalid or was removed."));
  }, [token]);

  return (
    <div className="min-h-screen bg-[#05070C] text-white flex items-center justify-center p-4 sm:p-8" data-testid="recording-share-page">
      <div className="w-full max-w-4xl">
        <div className="text-[11px] font-mono uppercase tracking-[0.25em] text-[#22D3EE] mb-3">TeachingSoftware.ai / class recording</div>
        {err ? (
          <div className="bg-[#0B1220] border border-red-400/30 rounded-2xl p-10 text-center" data-testid="recording-share-error">
            <div className="text-lg font-display font-bold">Recording unavailable</div>
            <p className="text-sm text-neutral-400 mt-2">{err}</p>
          </div>
        ) : !rec ? (
          <div className="text-neutral-400 text-sm">Loading recording…</div>
        ) : (
          <div className="bg-[#0B1220] border border-white/10 rounded-2xl overflow-hidden">
            <div className="px-6 py-4 border-b border-white/10 flex flex-wrap items-center gap-x-4 gap-y-1">
              <h1 className="font-display font-bold text-xl tracking-tight inline-flex items-center gap-2" data-testid="recording-share-title">
                <Video size={18} className="text-[#22D3EE]" /> {rec.title}
              </h1>
              <div className="text-xs text-neutral-400 inline-flex items-center gap-1.5">
                <CalendarDays size={12} /> {(rec.start_time || "").slice(0, 16).replace("T", " ")}
                {rec.subject ? ` · ${rec.subject}` : ""}
                {rec.teacher_name ? ` · ${rec.teacher_name}` : ""}
              </div>
            </div>
            <video
              src={`${BACKEND}${rec.recording_url}`}
              controls
              autoPlay
              playsInline
              className="w-full bg-black aspect-video"
              data-testid="recording-share-video"
            />
            <div className="px-6 py-3 text-[11px] text-neutral-500 font-mono">
              Shared privately by the teacher · {rec.size_mb ? `${rec.size_mb} MB` : "streamed"}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
